import { createRef, Fragment, HTMLAttributeAnchorTarget, useCallback, useEffect, useRef, useState } from "react";
import { useTranslation, Trans } from "react-i18next";

import { TitleH1, TitleH2 } from "components/generic";

import { FaqDiv, FaqSection, FaqTitle, MainPlace, NavFaq } from "./styles";
import { NavHashLink } from "react-router-hash-link";
import { HomeDiv, ItemLink } from "../styles";
import { HeaderSEO } from "components/headerSEO";
import { ISeo } from "interfaces/intarfaces";
import { publicRoutes, publicRoutesHospi } from "../../../routes";

interface IFaq {
  [nameProp: string]: { title: string; links: string[] };
}

interface IFaqQA {
  q: string;
  a: string;
  link: string[];
}


export const Faq = () => {


  const { t, i18n } = useTranslation("faq");
  const titlesNav: IFaq = t("chapter", { returnObjects: true });

  const getLinks = (k: string): string[] => {
    return t("chapter." + k + ".links", { returnObjects: true });
  };

  const getAllcapterLinks = (): string[] => {
    return Object.keys(titlesNav)
      .map((chapter) =>
        t("chapter." + chapter + ".links", { returnObjects: true })
      )
      .flatMap((items) => items);
  };

  const getQuestions = (k: string): IFaqQA[] => {
    return t(k + ".qa", { returnObjects: true });
  };


  type SomeFunction = (...args: any[]) => void;
  type Timer = ReturnType<typeof setTimeout>;

  function useDebounce<Func extends SomeFunction>(func: Func, delay: number) {
    const [timer, setTimer] = useState<Timer>();

    const debouncedFunction = ((...args) => {
      const newTimer = setTimeout(() => {
        func(...args);
      }, delay);
      clearTimeout(timer);
      setTimer(newTimer);
    }) as Func;

    return debouncedFunction;
  }


  function hanldeClass() {
    return sectionList.map(
      (item: any) => {
        const element = sectionRefs[sectionList.indexOf(item)]
        const target = document.querySelector(`#${item}`);
        const top = target?.getBoundingClientRect().top || 0;
        if (top >= 0 && top <= window.innerHeight - 200) {
          sectionRefs.forEach(sitem => {
            if (sitem) {
              sitem.className = ""
            }
          });
          element.className = "active"
        };
      }
    );
  }


  const onScroll = useDebounce(() => {
    hanldeClass()
  }, 500);

  const sectionList = getAllcapterLinks()//.map((capterLink) => {getQuestions(capterLink).map((qa) => {qa.q})});

  const sectionRefs: HTMLAnchorElement[] = [];

  const setRef = (ref: HTMLAnchorElement) => {
    sectionRefs.push(ref);
  };

  useEffect(() => {
    hanldeClass()

    const hospimain = document.getElementById("hospi-main")
    if (hospimain !== null) {
      hospimain.addEventListener("scroll", onScroll);
    };

    return () => { if (hospimain !== null) { hospimain.removeEventListener("scroll", onScroll); } }
  });

  const seo = t("seo", { returnObjects: true }) as ISeo;

  return (
    <FaqDiv>
      {seo && <HeaderSEO {...seo} />}
      <FaqTitle>{t("title")}</FaqTitle>
      <FaqSection>
        <div id='sticky-container'>
          <div id='sticky-faq'>
            <NavFaq>
              {Object.keys(titlesNav).map((chapter, num) => (
                <Fragment key={num}>
                  <TitleH2>{t("chapter." + chapter + ".title")}</TitleH2>
                  <ul>
                    {getLinks(chapter).map((item) => (
                      <li key={item}>
                        <NavHashLink ref={setRef} to={"#" + item}>
                          {t(item + ".title")}
                        </NavHashLink>
                      </li>
                    ))}
                  </ul>
                </Fragment>
              ))}
            </NavFaq>
          </div>
        </div>
        <MainPlace>
          {getAllcapterLinks().map((capterLink) => (
            <section id={capterLink}>
              <TitleH1 id={capterLink + "-title"}>{t(capterLink + ".title")}</TitleH1>
              <ul>
                {getQuestions(capterLink).map((qa, num) => (
                  <li key={qa.q}>
                    <p>{`Q: ${qa.q}`}</p>
                    <p style={{ whiteSpace: "pre-wrap" }}>
                      {`A: `}
                      <Trans
                        t={t}
                        i18nKey={capterLink + ".qa." + num + ".a"}
                        components={qa.link.map((item) => {
                          return <ItemLink
                            href={[...publicRoutesHospi, ...publicRoutes].map(({ path }) => path.slice(5)).includes(item.slice(1)!) ?
                              `/${i18n.language}${item.slice(1)}` : item === '#/blog/post2' ?
                                `/${i18n.language}${item.slice(1)}` : item!}
                            target="_blank" />
                        }

                        )}
                      />
                    </p>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </MainPlace>
      </FaqSection>
      <div style={{ height: 1, background: 'white' }} />
    </FaqDiv>
  );
};
